"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reducerUtil = _interopRequireDefault(require("./reducerUtil"));

var _api = require("./api");

var _config = require("./config");

var _login = require("./login");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * composeEnhancers is used for the visualising the Redux dev tools.
 * When REACT_APP_ENVIRONMENT env variable is set to 'DEVELOPEMENT' it will display the redux dev tools.
 */
var composeEnhancers;

if (process.env.REACT_APP_ENVIRONMENT === 'DEVELOPMENT') {
  composeEnhancers = global.window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
} else {
  composeEnhancers = _redux.compose;
}

var createReducer = function createReducer(reducers) {
  var _objectSpread2;

  return (0, _redux.combineReducers)(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, _config.reducerData.name, _reducerUtil["default"].create(_config.reducerData)), _defineProperty(_objectSpread2, _api.reducerData.name, _reducerUtil["default"].create(_api.reducerData)), _defineProperty(_objectSpread2, _login.reducerData.name, _reducerUtil["default"].create(_login.reducerData)), _objectSpread2), reducers));
};

var createStore = function createStore(reducers) {
  return (0, _redux.createStore)(createReducer(reducers), getInitialState(), composeEnhancers(_redux.applyMiddleware.apply(void 0, [_reduxThunk["default"]])));
};

var getInitialState = function getInitialState() {
  var preloadedState = global.window && window.preloadedState;
  if (preloadedState) delete window.preloadedState;
  return preloadedState || {};
};

var _default = createStore;
exports["default"] = _default;